export const REPO_TYPE_R = 'R'
export const REPO_TYPE_PYTHON = 'Python'
export const REPO_TYPE_BIOCONDUCTOR = 'Bioconductor'
